import { render, staticRenderFns } from "./IpControl.vue?vue&type=template&id=5974256a&scoped=true&"
import script from "./IpControl.vue?vue&type=script&lang=js&"
export * from "./IpControl.vue?vue&type=script&lang=js&"
import style0 from "./IpControl.vue?vue&type=style&index=0&id=5974256a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5974256a",
  null
  
)

export default component.exports